import React, { useEffect } from "react";
 
import Navbar from "../components/homepage/Navbar";
// import SuvidhaKendra from "../components/suvidhakendra/SuvidhaKendra";
// import DSK from "../components/suvidhakendra/DSK";
import DSKLanding from "./DSKLanding";
import { Header, Footer } from "../shared";

const JobsHirePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="bg_darkblue">
        {/* <Header /> */}
      </div>
      {/* <SuvidhaKendra /> */}
      <DSKLanding />
      {/* <Footer /> */}
    </div>
  );
};

export default JobsHirePage;
